
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/dpo",
      function () {
        return require("private-next-pages/services/dpo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/dpo"])
      });
    }
  